export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/project-new-add-bg-d7c01ebb487a927f6facd65df359da29.png";